/* eslint-disable react-hooks/exhaustive-deps */
import { notification } from "antd";
import React, { createContext, useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";
import { useLocation } from "react-router";
import socketIOClient from 'socket.io-client';
import useNotifications from "./notifications";
import { checkIfUrlIsIgnored } from "./helper";

export const SocketContext = createContext();

export const SocketProvider = ({ children, theme }) => {
  const auth = useSelector((state) => state.authentication);
  const [socket, setSocket] = useState(null);
  const [socketStarted, setSocketStarted] = useState(false);
  const [user, setUser] = useState(null);
  const location = useLocation();
  const currentURL = useMemo(() => location.pathname, [location]);
  const ignore = useMemo(() => checkIfUrlIsIgnored(currentURL), [currentURL]);
  const [api, contextHolder] = notification.useNotification();

  const notifications = useNotifications({ socket, ignore, api });

  useEffect(() => {
    if (auth.user && (user || {}).id !== auth.user?.company?.id) {
      setUser(auth.user);
    } else if (!auth.user) {
      stopSocket();
      setUser(null);
    }
  }, [auth]);

  const startSocket = () => {
    const socketUrl = process.env.REACT_APP_SOCKET_GATEWAY_ENDPOINT || 'http://localhost:4001';
    const s = socketIOClient(socketUrl, {
      transports: ['websocket'],
      path: '/datastake-socket',
      withCredentials: false,
      secure: process.env.REACT_APP_SOCKET_GATEWAY_ENDPOINT === 'http://localhost:4001' ? false : true,
      query: {
        token: user?.company?.id,
      },
    });
    setSocket(s);
  };

  const stopSocket = () => {
    if (socket) {
      socket.close();
      setSocket(null);
    }
  }

  useEffect(() => {
    if (user) {
      startSocket();
    }
  }, [user]);

  useEffect(() => {
    if (socket) {
      socket.on('connect', () => {
        setSocketStarted(true);
      });
      socket.on('disconnect', () => {
        setSocketStarted(false);
      });
    }
  }, [socket]);

  return (
    <SocketContext.Provider
      value={{
        ...notifications,
        startSocket,
        stopSocket,
        socketStarted,
        theme,
      }}
    >
      {children}
      {contextHolder}
    </SocketContext.Provider>
  )
};
